<template>
    <div :class="cls">
        <div :class="field.wrapClass ?? ''" class="w-100" v-for="field in formFields">
            <slot :name="'field-' + field.name" :field="field">
                <section v-if="field.type === 'section'">
                    <div class="d-sm-flex align-items-center justify-content-between mb-2 mt-3"><h5
                        class="mb-0 text-dark">
                        {{ field.label }}</h5></div>
                    <form-input-builder :fields="field.fields" v-model="model" @change="mergeModel($event)"/>
                </section>
                <autoload-select v-else-if="field.type === 'select' && field.url"
                                 v-bind="getFieldBindings(field, model)"
                                 @input="updateModel(field.name, $event?.value ?? $event, true)"/>
                <basic-select v-else-if="field.type === 'select'" placeholder="Select One"
                              :multiple="field.multiple ?? false"
                              v-bind="getFieldBindings(field, model)"
                              @input="updateModel(field.name, $event?.value ?? $event, true)"/>
                <basic-date-picker v-else-if="field.type === 'date'"
                                   v-bind="getFieldBindings(field, model)"
                                   @input="updateModel(field.name, $event)"/>
                <basic-input v-else
                             v-bind="getFieldBindings(field, model)"
                             @input="updateModel(field.name, $event)"/>
            </slot>
        </div>
    </div>
</template>

<script>
import BasicInput from "../atoms/BasicInput.vue";
import BasicSelect from "../atoms/BasicSelect.vue";
import AutoloadSelect from "../atoms/AutoloadSelect.vue";
import BasicDatePicker from "../atoms/BasicDatePicker.vue";
import {randomString} from "../../services/Defaults";

export default {
    name: "FormInputBuilder",
    components: {
        BasicDatePicker,
        AutoloadSelect,
        BasicInput,
        BasicSelect,
    },
    props: {
        fields: {
            type: Array,
            required: true
        },
        value: {
            type: Object,
            required: false
        },
        errors: {
            type: Object,
            required: false
        },
        cls: {
            type: String,
            required: false,
            default: 'row mb-2'
        },
    },
    watch: {
        errors: {
            handler() {
                this.fields.forEach(field => {
                    field.error = this.errors[field.name] ? this.errors[field.name].join(', ') : null
                })

                this.formFields = [...this.fields]
            },
            deep: true
        },
        fields: function (val) {
            this.formFields = val;
            this.$emit('fieldsChange', this.formFields)
        },
        value: function (val) {
            this.model = val;
        },
    },
    data() {
        return {
            model: this.value ?? {},
            formFields: this.fields
        }
    },
    methods: {
        updateModel(name, value, skipModelUpdate = false) {
            if (skipModelUpdate) {
                this.$emit('input', {...this.model, [name]: value});
                this.$emit('change', {...this.model, [name]: value});
                return;
            }
            this.model[name] = value;
            this.emitData()
        },
        mergeModel(model) {
            this.model = {...this.model, ...model}
            this.emitData()
        },
        emitData() {
            this.$emit('input', this.model);
            this.$emit('change', this.model);
        },
        getFieldBindings(field, model) {
            return {
                ...field,
                value: model[field.name] !== undefined ? model[field.name] : field.value,
            };
        },
    },
}
</script>
